import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import router from '@/router';
axios.interceptors.response.use(function (config) {
  return config;
}, function (error) {
  var _error$message;
  // console.log('error obj in axios interceptor response', error)

  if (error.response.status && error.response.status === 401) {
    localStorage.removeItem('userDetail');
    router.push({
      path: 'login'
    }).catch(function (err) {
      return console.log('router push has error', err);
    });
  } else if (error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.includes('status code 500')) {
    return Promise.reject(error);
  } else {
    return Promise.reject(error.response.data);
  }
});
export default axios;